import { PERSONAL_DATA_FORM_FIELDS_NAMES } from "../reducers/personalDataForm";
import { SUPPLY_ADDRESS_FORM_FIELD_NAMES } from "../reducers/supplyAddressForm";
import { PAYMENT_RECAP_FIELD_NAMES } from "../reducers/paymentRecap";

const INTEGER_FIELDS = [
    PERSONAL_DATA_FORM_FIELDS_NAMES.offerId,
    PERSONAL_DATA_FORM_FIELDS_NAMES.mobilePhone,
    
    SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressNumber,
    SUPPLY_ADDRESS_FORM_FIELD_NAMES.cap,
    SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressNumber,
    SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceCap,
    SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyAddressNumber,
    SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyCap,
    SUPPLY_ADDRESS_FORM_FIELD_NAMES.pdr,
    SUPPLY_ADDRESS_FORM_FIELD_NAMES.pod,
    SUPPLY_ADDRESS_FORM_FIELD_NAMES.energyConsumption,
    SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentGasConsumption,

    PAYMENT_RECAP_FIELD_NAMES.billAddressNumber,
    PAYMENT_RECAP_FIELD_NAMES.billAddressCap,
]

export const removeBlankValuesObject = object => {
    return Object.keys(object).reduce((prev, v) => {
        if (object[v] === null || object[v] === undefined) {
            return prev;
        } else {
            // if (false && (object[v] === "1" || object[v] === "0") && !INTEGER_FIELDS.includes(v)) {
            //     prev[v] = object[v] === "1";
            // }
            if (v === PERSONAL_DATA_FORM_FIELDS_NAMES.timeSpent) {
                prev[v] = parseInt(object[v], 10);
            } else if (typeof object[v] === "object") {
                const objectField = removeBlankValuesObject(object[v]);
                if (Object.keys(objectField).length === 0) {
                    return prev;
                } else {
                    prev[v] = objectField;
                    return prev;
                }
            } else {
                prev[v] = object[v];
            }
            return prev;
        }
    }, {});
}